import { createClient } from "@supabase/supabase-js"; // 从 @supabase/supabase-js 导入 createClient 函数

// 根据当前的 NODE_ENV 环境变量来选择合适的 Supabase URL
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

// 使用选定的 URL 和密钥创建 Supabase 客户端
const supabase = createClient(supabaseUrl, supabaseKey);
export default supabase; // 导出创建的 Supabase 客户端实例